module.exports = __webpack_public_path__ + "static/media/forum-eunos.af146f78.jpg";